import { ActionMenu, ConfirmationDialog } from '@ijoin/components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { camelCase } from 'lodash';
import { useToggle } from 'usehooks-ts';

export const MethodologyActionsCell = (props: {
  message?: string;
  name: string;
  onUnlink: () => void;
  title?: string;
}) => {
  const [isUnlinkOpen, toggleUnlinkOpen] = useToggle();

  const onConfirmUnlink = () => {
    toggleUnlinkOpen();
    props.onUnlink();
  };

  return (
    <>
      <ActionMenu
        actions={[{ content: 'Unlink', onSelect: toggleUnlinkOpen }]}
        trigger={
          <IconButton data-testid={`actions-${camelCase(props.name)}`}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      <ConfirmationDialog
        confirmColor='error'
        confirmText='Unlink'
        data-testid={camelCase(`unlink ${props.name}`)}
        isOpen={isUnlinkOpen}
        message={
          props.message ??
          `Unlink ${props.name} from this advisory organization?`
        }
        onCancel={toggleUnlinkOpen}
        onConfirm={onConfirmUnlink}
        title={props.title ?? 'Unlink Methodology'}
      />
    </>
  );
};
